<template>
  <div id="content" v-if="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <broadcast-search
        v-model="entity.id_broadcasts"
        @broadcast-search-names="broadcastNames = arguments[0]"
        ref="broadcastsearchref"
    />
    <div class="inner">
      <p class="paging" v-if="isSubscriber">
        <router-link :to="{ name: 'subscriberDetail', params: {id: entity.id_subscriber, tab: 'dashboard'} }" class="btn btn_back" v-translate>Seznam</router-link>
      </p>
      <p class="paging" v-else>
        <router-link :to="{ name: 'dashboardCarousels'}" class="btn btn_back" v-translate>Seznam</router-link>
      </p>
      <p class="buttons">
        <a v-if="allowDelete && !isOperatorEditGlobal" @click.stop.prevent="deleteEntity(true, redirectParams)" class="btn btn_action btn_delete" :title="$gettext('Smazat')" v-translate>Smazat</a>
        <a v-if="allowDelete && isOperatorEditGlobal && entity.is_overriden" @click.stop.prevent="deleteEntity(true, redirectParams)" class="btn btn_action btn_reset" :title="$gettext('Resetovat')" v-translate>Resetovat</a>
      </p>
      <h1 v-if="entity">{{ entity.name }}</h1>
    </div>
    <div class="responsiveTabs r-tabs" v-if="entity">
        <BasicInfo
            :entity="entity"
            :editable="allowEdit"
            :broadcast-names="broadcastNames"
            @broadcast-search-modal="$refs.broadcastsearchref.showModal(true, arguments[0])"
            @broadcast-search-names="broadcastNames = arguments[0]"
        />
      <section class="buttons">
        <p>
          <router-link  v-if="isSubscriber" :to="{ name: 'subscriberDetail', params: {id: entity.id_subscriber, tab: 'dashboard'} }" class="btn btn_back btn_seznam" v-translate>Seznam
          </router-link>
          <router-link  v-else :to="{ name: 'dashboardCarousels'}" class="btn btn_back btn_seznam" v-translate>Seznam
          </router-link>
          <input v-if="allowEdit" type="submit" :value="'Uložit' | translate"
                 :class="['btn']"
                 @click.prevent.stop="submitForm()">
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions";
import dashboardCarousel from "./mixins/dashboardCarousel";
import BasicInfo from "./detail/BasicInfo";
import BroadcastSearch from "../../common/BroadcastSearch.vue";

export default {
  name: "DashboardCarouselDetail",
  components: {BasicInfo, BroadcastSearch},
  mixins: [detailActions, dashboardCarousel],
  data() {
    return {
      entity: null,
      broadcastNames: {},
    };
  },
  created(DashboardCarouselService) {
    this.entityService = DashboardCarouselService;
    this.createdInit();
  },
  computed:{
    isOperatorEditGlobal(){
      return this.entity.global && this.$_loggedUser_selectedOperatorId
    },
    allowEdit(){
      if(this.entity){
        return this.$_updateActionAllowed
      }else{
        return false;
      }
    },
    allowDelete(){
      return this.$_updateActionAllowed;
    }
  },
  methods: {
    _afterGetEntityActions() {
      this.searchBroadcastsById(this.entity.id_broadcasts);
    },
    searchBroadcastsById(ids) {
      if (!ids || ids.length === 0) {
        return;
      }
      this.entityService.searchBroadcastsByName({ ids: ids.join(',') }).then(response => {
        this.broadcastNames = {}
        response.data.forEach(item => {
          this.broadcastNames[item.id] = item
        })
      })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/dashboardCarousels/DashboardCarouselDetail.vue